export class PricingElementEntity {
    constructor() {}
    planId: string
    title: string
    price: number
    months: number
    installments: number
    conditions: string
    items: { title: string; checked: true }[] = []
    extras: { title: string; price: number; checked: boolean; [key: string]: any }[] = []
    metadata: { plan: string; items: string[] }
    coupons: string[];
    [key: string]: any
}
